// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__3tfGg","header":"index_header__GNpDb","link":"index_link__3UofU","spaceholder":"index_spaceholder__2QluG","info":"index_info__1sxPl"};